<template>
  <p-selection-child
    v-slot="selection"
    :tag="tag"
    class="p-list-entry-wrapper"
    :value="selectionValue"
    register-only-with-root-parent
    @active="onActiveChange"
  >
    <div :class="{...classList}" @click="onClick(selection)" @keypress.space="onClick(selection)">
      <div v-if="hasIconLeft" class="p-list-entry-icon-left">
        <slot name="icon-left">
          <p-icon>{{ iconLeft }}</p-icon>
        </slot>
      </div>

      <p-row class="p-list-entry-text" column no-gutters>
        <p-col>
          <span class="p-list-entry-title">
            <slot name="title"></slot>
            <slot></slot>
          </span>
        </p-col>
        <p-col>
          <div v-if="hasSubtitle" class="p-list-entry-subtitle caption-1">
            <slot name="subtitle"></slot>
          </div>
        </p-col>
      </p-row>

      <div v-if="hasIconRight" class="p-list-entry-icon-right">
        <slot name="icon-right">
          <p-icon>{{ iconRight }}</p-icon>
        </slot>
      </div>
    </div>
  </p-selection-child>
</template>

<script lang="ts">
  import Vue from 'vue';
  import interactable from '../../mixins/interactable/interactable';
  import colorable from '../../mixins/colorable/colorable';
  import mixins from '../../mixins';

  export default mixins(interactable, colorable).extend({
    mixins: [interactable, colorable],
    props: {
      value: { type: undefined, default: undefined },
      tag: { type: String, default: 'li' },
      color: { type: String, default: 'text' },
      iconRight: { type: String, default: undefined },
      iconLeft: { type: String, default: undefined },
      to: { type: String, default: undefined },
    },
    data: () => ({
      isActive: false,
    }),
    computed: {
      hasIconLeft() {
        return this.iconLeft || this._.component.hasSlot(this, 'icon-left');
      },
      hasIconRight() {
        return this.iconRight || this._.component.hasSlot(this, 'icon-right');
      },
      hasSubtitle() {
        return this._.component.hasSlot(this, 'subtitle');
      },
      selectionValue() {
        return this.value ?? this.to;
      },
      classList() {
        return {
          'p-list-entry': true,
          active: this.isActive,
          [`text-color-${this.color}`]: this.color !== undefined && !this.disabled,
          'color-readonly': this.disabled,
          'text-color-readonly': this.disabled,
        };
      },
    },
    watch: {
      $route: {
        handler() {
          this.isActive = Vue.$routerUtils.insideRoute(this.to);
        },
      },
    },
    mounted() {
      this.isActive = Vue.$routerUtils.insideRoute(this.to);
    },
    methods: {
      onActiveChange(isActive: boolean) {
        this.isActive = isActive;
      },
      onClick(selection: {toggle: ()=>{}}) {
        if (this.disabled) {
          return;
        }
        if (this.to !== undefined) {
          const alreadyInRoute = Vue.$routerUtils.insideRoute(this.to);
          if (!alreadyInRoute) {
            this.$emit('click');
            this.$nextTick(() => {
              Vue.$router.push(this.to);
            });
          }
        } else {
          selection.toggle();
          this.$emit('click');
        }
      },
    },
  });
</script>
